import { getDashboardLayout } from 'src/Components/Layouts/DashboardLayout';
import { RouterLinks } from 'src/routing/routerLinks';
import { useAsmRouter } from 'src/utils/hooks';

const Page = () => {
  const router = useAsmRouter();
  router.pushFlat(RouterLinks.Appointments);
  return null;
};

Page.getLayout = getDashboardLayout(RouterLinks.Appointments);

export default Page;
